// Asistente de IA (D39, D46): la cuenta de Claude y/o de ChatGPT de cada persona, conectadas en el servicio del
// asistente. Las sesiones las guardan los propios programas oficiales (Claude Code y Codex) en el servidor; la Consola
// nunca ve credenciales.
import { ApiError, enviarConSesion, request, subirConSesion } from './http';

export type Proveedor = 'claude' | 'chatgpt';
export const PROVEEDORES: Proveedor[] = ['claude', 'chatgpt'];
export type ModeloIA = { id: string; nombre: string };
export type CuentaIA = { nombre?: string; conectado: boolean; metodo: string | null; correo: string | null; plan: string | null; modelo: string; modelos: ModeloIA[] };
// Arriba, los datos del proveedor elegido (con el que se conversa); en `cuentas`, los dos.
export type EstadoAsistente = CuentaIA & { proveedor?: Proveedor; cuentas?: Record<Proveedor, CuentaIA> };

// Para que sirve cada modelo (se muestra al elegirlo).
export const USO_MODELO: Record<string, string> = {
  haiku: 'El más rápido y liviano: qué revisar, buscar casos, preguntas cortas. Siempre la versión más nueva.',
  sonnet: 'Equilibrado: resúmenes, ordenar el día, borradores de respuesta. Siempre la versión más nueva.',
  opus: 'Para casos difíciles o conversaciones largas. Siempre la versión más nueva.',
  fable: 'El más capaz; gasta más del cupo de tu plan. Siempre la versión más nueva.',
  predeterminado: 'El modelo que ChatGPT usa por defecto con tu plan.',
  'gpt-6.1-sol': 'El más reciente para el día a día: resúmenes, ordenar el día, borradores.',
  'gpt-6-astra': 'El más capaz, para casos difíciles; gasta más del cupo de tu plan.',
  'gpt-6-luna': 'Rápido y liviano: buscar casos, preguntas cortas.',
};

// Claude da un enlace y luego un codigo para pegar aqui; ChatGPT da un enlace y un codigo para escribir en su pagina,
// y la Consola pregunta hasta que se autoriza.
export type Conexion = { url: string; codigo: string | null };
export type Seguimiento = { resultado: 'esperando' | 'conectado' | 'fallo' | 'vencido' } & Partial<EstadoAsistente>;

export const estadoAsistente = () => request<EstadoAsistente>('/asistente/api/estado');
export const iniciarConexion = (proveedor: Proveedor = 'claude') => request<Conexion>('/asistente/api/conectar', { method: 'POST', body: { proveedor } });
export const terminarConexion = (codigo: string) => request<EstadoAsistente>('/asistente/api/conectar/codigo', { method: 'POST', body: { codigo } });
export const seguirConexion = (proveedor: Proveedor) => request<Seguimiento>('/asistente/api/conectar/estado', { query: { proveedor } });
export const elegirModelo = (modelo: string, proveedor?: Proveedor) => request<EstadoAsistente>('/asistente/api/modelo', { method: 'PUT', body: { modelo, proveedor } });
export const elegirProveedor = (proveedor: Proveedor) => request<EstadoAsistente>('/asistente/api/proveedor', { method: 'PUT', body: { proveedor } });
export const desconectarAsistente = (proveedor: Proveedor = 'claude') => request<{ ok: boolean }>('/asistente/api/conectar', { method: 'DELETE', query: { proveedor } });

// Adjuntos del chat (D89): el archivo va tal cual al servicio, que lo guarda 24 horas para que Amix lo lea con
// leer_subido. Las imagenes grandes se achican antes en el navegador (achicarImagen).
export type AdjuntoAmix = { id: string; nombre: string; tipo: string; tamano: number };
// PDF de un documento de Amix (D93): el servidor convierte el .docx con formato XmarteK, asi sale igual al Word.
export async function pdfDeDocx(docx: Blob): Promise<Blob> {
  const r = await enviarConSesion('/asistente/api/pdf', docx);
  if (!r.ok) {
    const j = (await r.json().catch(() => null)) as { mensaje?: string } | null;
    throw new ApiError(r.status, j?.mensaje || `No se pudo hacer el PDF (${r.status}).`);
  }
  return new Blob([await r.arrayBuffer()], { type: 'application/pdf' });
}

export const subirArchivoAmix = (archivo: Blob, nombre: string) => subirConSesion<AdjuntoAmix>('/asistente/api/subir', archivo, { 'X-Nombre': encodeURIComponent(nombre) });
